import React from 'react'
import { get, post } from 'client/utils/api-routes.util'
import { OrdersContext } from 'contexts/OrdersContext'
import _ from 'lodash'
import moment from 'moment'
import {
  DcButton,
  DcInput,
  PixelAlert,
  PixelFactoryContext,
  DcDropDown,
  DcTag,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../decl.d'
export interface SelectedOrder {
  shipping: {
    first_name: string
    last_name: string
    city: string
    phone: string
  }
  meta: {
    order_source: string
  }
  courier: {
    courier_name: string
    tracking_id: string
  }
  status: string
  number: number
  source_order_id: number
  store_order_id: number
  split_source_order_id: string | null
  date_created: string
  weight: number
  total: number
  customer_id: number
  store_id: number
  is_returning: boolean
  is_refuser: boolean
  is_duplicate: boolean
  is_split_child: boolean
  is_split_main: boolean
  split_child_ids: string
  split_main_id: string
  status_classification_id: number
  last_comment: string
  wa_is_read_flag: number
  is_customer_note: number
  exchanged_from_order_id: number | null
  customer_notes: string
  is_editable: boolean
}

interface IProps {
  selectedOrders: SelectedOrder[]
  handleClose: () => void
  handleUpdate: (orderIds: number[], action: string) => void
}
const PrepareOrdersDispatch = (props: IProps) => {
  const { selectedOrders: orders } = props
  const { state: ordersState } = React.useContext(OrdersContext)
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [state, setState] = React.useState<any>({
    error: null,
    courier: null,
    courierName: null,
    activeDispatchesList: [],
    activeDispatch: {},
    selectedDispatchID: 'new',
    dispatchName: '',
    selectedWarehouseID: null,
  })
  const validateDispatchData = () => {
    if (!orders) {
      setState({
        ...state,
        error: 'No Order Selected',
      })
    }
    if (orders && orders.length) {
      // check if all orders have same courier
      const isSameCourier = _.groupBy(
        orders,
        (order) => order['courier']['courier_name'],
      )
      if (Object.keys(isSameCourier).length > 1) {
        setState({
          ...state,
          error: 'Selected Orders have different couriers',
        })
        return
      }
      if (
        orders[0]['courier'] &&
        orders[0]['courier']['tracking_id'] &&
        orders[0]['courier']['tracking_id'] !== 'error' &&
        orders[0]['courier']['tracking_id'] !== 'timeout'
      ) {
        const courier_name = orders[0]['courier']['courier_name']

        if (!courier_name) {
          setState({
            ...state,
            error: 'Create consignments before creating the dispatch',
          })
        }

        orders.map((o) => {
          if (!o['courier'] || o['courier']['courier_name'] !== courier_name) {
            setState({
              ...state,
              error:
                'To create a dispatch all consignments should belong to the same courier',
            })
          }
        })

        if (!state.error) {
          state.courierName = courier_name
        }
      } else {
        setState({
          ...state,
          error:
            'Order does not have a consignment. First create the consignment for a courier and then create a dispatch',
        })
      }
    }
  }

  React.useEffect(() => {
    validateDispatchData()
    if (!state.error) {
      const couriers_list = [...ordersState.couriers]
      state.courier = couriers_list.filter(
        (c) => c['courier_name'] === state.courierName,
      )[0]
      if (state.courier) {
        const { courier_id } = state.courier
        getActiveDispatchs(courier_id)
      }
    }
  }, [])

  const getActiveDispatchs = (courier_id) => {
    showPageLoader()
    get(`/courier/${courier_id}/dispatch`).subscribe(
      (res: AjaxResponse<any>) => {
        hidePageLoader()
        if (res.response.data) {
          const isDefault = ordersState.warehouses.find((w) => w.is_default)
          setState({
            ...state,
            selectedWarehouseID: isDefault?.wh_id,
            activeDispatchesList: res.response.data,
          })
        }
      },
    )
  }
  const applyBulkAction = (e) => {
    e.preventDefault()
    showPageLoader()
    if (state.courier['courier_id']) {
      const data = {
        courier_id: state.courier['courier_id'],
        dispatch_id: state.selectedDispatchID,
        dispatch_name: state.dispatchName,
        orders: null,
        warehouse_id:
          state.selectedWarehouseID === 'new'
            ? null
            : state.selectedWarehouseID,
      }
      data['orders'] = orders.map((o) => {
        return {
          order_id: o['number'],
          tracking_id: o['courier']['tracking_id'],
        }
      })

      post('/orders/bulk/dispatch', data).subscribe(
        (res: AjaxResponse<any>) => {
          hidePageLoader()
          if (!res.response) {
            showFailure('Could not create dispatch')
          }
          if (res.response['error']) {
            showFailure(res['error'])
          }

          if (res.response && res.response['dispatch_id']) {
            showSuccess(
              `Dispatch created successfully. Dispatch ID ${res.response['dispatch_id']}`,
            )
            //   orderService.isHardRefreshNeeded.next(orders);
            props.handleClose()
            props.handleUpdate(data['order_ids'], 'prepareDispatch')
          }
        },
      )
    } else {
      showFailure('Create consignment first too start a dispatch process')
    }
  }
  return (
    <>
      {state.error && <PixelAlert variant="danger">{state.error}</PixelAlert>}
      <Form onSubmit={applyBulkAction}>
        {!state.error && state.courier && (
          <>
            <FormGroup>
              <DcDropDown
                required
                value={state.selectedDispatchID}
                placeholder="Select Dispatch"
                options={[
                  {
                    value: 'new',
                    label: 'New Dispatch',
                  },

                  ...state.activeDispatchesList.map((d) => {
                    return {
                      value: d['dispatch_id'],
                      label: `${d['courier_name']} - ${moment(
                        d['created_at'],
                      ).format('ll, h:mm:ss A')} - ${d['dispatch_id']}`,
                    }
                  }),
                ]}
                onChange={(e) => {
                  const currentDispatch = state?.activeDispatchesList?.find(
                    (item: any) => item.dispatch_id === e.target.value,
                  )
                  setState({
                    ...state,
                    selectedDispatchID: e.target.value,
                    activeDispatch: currentDispatch,
                    selectedWarehouseID: currentDispatch?.warehouse_id,
                  })
                }}
              />
              {state.selectedDispatchID === 'new' ? (
                <>
                  <DcDropDown
                    placeholder="Select Warehouse"
                    required
                    value={state.selectedWarehouseID}
                    options={[
                      {
                        value: null,
                        label: 'Select Warehouse',
                      },

                      ...ordersState.warehouses.map((w) => {
                        return {
                          value: w['wh_id'],
                          label: w['name'],
                        }
                      }),
                    ]}
                    onChange={(e) => {
                      setState({
                        ...state,
                        selectedWarehouseID: e.target.value,
                      })
                    }}
                  />
                  {state?.selectedDispatchID == 'new' && (
                    <DcInput
                      required
                      value={state?.dispatchName || ''}
                      placeholder="Dispatch Name"
                      onChange={(e) => {
                        setState({
                          ...state,
                          dispatchName: e.target.value,
                        })
                      }}
                    />
                  )}

                  <DetailLines>
                    Order Selected:&nbsp;
                    <strong>{orders.length}</strong>
                  </DetailLines>
                  <DetailLines>
                    Courier:&nbsp;
                    <strong>{state.courier?.courier_name}</strong>
                  </DetailLines>
                </>
              ) : (
                <FormGroup>
                  <DetailLines>
                    Order Selected:&nbsp;
                    <strong>{orders.length}</strong>
                  </DetailLines>
                  <DetailLines>
                    Courier:&nbsp;
                    <strong>{state.courier?.courier_name}</strong>
                  </DetailLines>
                  <DetailLines>
                    Dispatch Status:&nbsp;
                    <DcTag>{state.activeDispatch?.status}</DcTag>
                  </DetailLines>
                  <DetailLines>
                    Dispatch Name:&nbsp;
                    <DcTag>{state.activeDispatch?.dispatch_name}</DcTag>
                  </DetailLines>
                  <DetailLines>
                    Total Packages:&nbsp;
                    <strong>{state.activeDispatch?.total_packages}</strong>
                  </DetailLines>
                  <DetailLines>
                    Total Pieces:&nbsp;
                    <strong>{state.activeDispatch?.total_pieces}</strong>
                  </DetailLines>
                  <DetailLines>
                    Dispatch Warehouse:&nbsp;
                    <strong>{state.activeDispatch?.warehouse_name}</strong>
                  </DetailLines>
                </FormGroup>
              )}
            </FormGroup>
            <FormGroup flexEnd>
              <DcButton size="sm" type="submit">
                {state.selectedDispatchID === 'new'
                  ? 'Create Dispatch'
                  : 'Update Dispatch'}
              </DcButton>
            </FormGroup>
          </>
        )}
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  justify-content: ${(props) => props.flexEnd && 'flex-end'};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
  .input {
    width: 49%;
    flex: 49%;
  }
  .phone-input {
    width: 49% !important;
  }
`

const DetailLines = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  font-size: 15px;
`

export default PrepareOrdersDispatch
